var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function mapConfig(config) {
    var defaultConfig = {
        duration: 2000,
        verticalPosition: 'top',
        horizontalPosition: 'right',
    };
    return __assign({}, defaultConfig, config);
}
export function mapAction(action) {
    return action ? action : 'Sluiten';
}
